// removed by extract-text-webpack-plugin
module.exports = {"centered":"centered__2NHp2","wrap":"wrap__1uL2a","dropdown":"dropdown__1-Q4n","dropdownInner":"dropdownInner__2GrYM","item":"item__10wBW","itemDesk":"itemDesk__mlu2O","itemMobile":"itemMobile__3Qpd4","splitter":"splitter__14so6"};


//////////////////
// WEBPACK FOOTER
// ./components/phone-input/style.styl
// module id = GqZF
// module chunks = 0